<h4 nz-typography class="title">{{ title | uppercase }}</h4>
<div class="actions">
  @if (atalhoAuditoria(); as atalho) {
    <a nz-button [routerLink]="['/auditoria', atalho.codigo]"
      [queryParams]="atalho.registro ? { registro: atalho.registro } : null">
      {{ i18n.t('FEATURES.AUDITORIA.ATALHO') }}
    </a>
  }
  <div class="user-container">
    @if (sessao.nomeExibicao(); as nome) {
      <strong class="user-name" [title]="nome">{{ nome }}</strong>
    }
    <nz-avatar [nzSize]="40" [nzText]="iniciais() || undefined" [nzIcon]="iniciais() ? undefined : 'user'"></nz-avatar>
  </div>
</div>
